export const enum ErrorCode {
  /** 不明なエラー */
  Unknown = '-1',

  /** セッションタイムアウト */
  InvalidJWTToken = '10',

  /** メンテナンス */
  Maintenance = 'CE01000',

  /** 不正な多言語情報が取得された */
  UnexpectedLocaleInfomation = 'CE01010',

  /** 規定回数内の生年月日認証失敗 */
  FailedBirthAuth = '2002',

  /** 規定回数以上の生年月日認証失敗 */
  ExpiresAtBirthAuth = '2003',

  /** 撮影結果の自動判定でNG 免許証の表・裏、顔正面 */
  CVInvalidFeature = '2007',

  /** 撮影結果の自動判定でNG 免許証の斜めの免許証の表と斜めの同一性確認 */
  CVDifferentDriverLicense = '2008',

  /** 申請に必要な情報が足りない */
  UnconfirmedDataset = '2010',

  /** 申請有効期限切れステータスエラー */
  KYCRequestExpiredStatus = '2011',

  /** 申請中ではない不正なステータスエラー */
  KYCRequestInvalidStatus = '2012',

  /** 確認画像のタイムアウトエラー */
  KYCRequestImageTimeout = '2013',

  // 利用できない補助書類コード
  ErrorCode2022 = '2022',

  // 指定できない補助書類の撮影枚数
  ErrorCode2023 = '2023'
}
